import { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import ProductCard from '../product/ProductCard'

const StoreBlockCatalog = ({ items, storeData, label = 'Products' }) => {
  const perPage = 10
  const [page, setPage] = useState(1)

  const visibleItems = items?.slice(0, page * perPage) ?? []
  const showMoreButtonVisible = visibleItems.length > 0 && items.length > page * perPage

  return (
    <div
      id={'catalog'}
      className={'d-flex flex-column gap-2'}
    >
      <div className={'d-flex flex-column gap-2'}>
        <h2 className={'m-0 fs-4'}>
          {label}
        </h2>
        {storeData && (
          <p className={'text-muted'}>
            {storeData.name} presents {items.length} product{items.length === 1 ? '' : 's'} in our collection
          </p>
        )}
      </div>

      {/* Empty State */}
      {Array.isArray(items) && items.length === 0 && (
        <div className="pt-5 pb-5 bg-light br-3">
          <div className={'pt-3 pb-3 text-center text-muted fs-5'}>
            Store is empty for now
          </div>
        </div>
      )}

      {/* Catalog */}
      {Array.isArray(items) && items.length > 0 && (
        <div className={'d-flex flex-column gap-5'}>
          <Row className="g-3 g-md-4 align-items-stretch">
            {visibleItems.map(item => (
              <Col
                key={item.id}
                xs={6} md={6} lg={4} xl={3}
                className="d-flex flex-column"
              >
                <ProductCard
                  item={item}
                />
              </Col>
            ))}
          </Row>

          {showMoreButtonVisible && (
            <div className="text-center">
              <Button
                variant="light"
                onClick={() => {
                  setPage(p => p + 1)
                }}
              >
                Show more
              </Button>
            </div>
          )}

          {visibleItems.length === 0 && (
            <div className='p-5 text-center text-muted'>
              No items here
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default StoreBlockCatalog
